import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const mainFirebaseConfig = {
  apiKey: "AIzaSyCYSID15DFd6sYR_RrosK8VzqIbGwlxeEI",
  authDomain: "ue-design-hub.firebaseapp.com",
  projectId: "ue-design-hub",
  storageBucket: "ue-design-hub.appspot.com",
  messagingSenderId: "873051402049",
  appId: "1:873051402049:web:d10010dc858f09c120bbc0",
};

export const app = initializeApp(mainFirebaseConfig);
export const auth = getAuth(app);
